import gql from 'graphql-tag';

export const getRoleAccess = gql`
	query GetRoleAccess {
		role {
			lavuPayOnboard
			lavuPayOffboard
		}
	}
`;

export default {
	getRoleAccess,
};
